import IndividualHead from "../assets/images/individual_head.png";
import DecisionHead from "../assets/images/decision_head.png";
import Diagnosis from "../assets/images/diagnosis_head.png";
import Functional from "../assets/images/functional_head.png";
import LifeStyle from "../assets/images/lifestyle_head.png";
import PainHead from "../assets/images/pain_head.png";
import Psychological from "../assets/images/psychosocial_head.png";
import Stage from "../assets/images/stage_head.png";
import WholePerson from "../assets/images/wholeperson_head.png";
import Work from "../assets/images/work_head.png";

export const inputTypes = {
  dropDown: "DROPDOWN",
  slider: "SLIDER",
  checkBoxGroup: "CHECKBOXGROUP",
  textArea: "TEXTAREA",
  textAreaGroup: "TEXTAREAGROUP",
};

export const tableData = [
  {
    title: "Individual's Perspective",
    titleImg: IndividualHead,
    bg: "#D0D2D3",
    subsClassName: "flex-row",
    subs: [
      {
        title: "",
        input: {
          type: inputTypes.textAreaGroup,
          textAreas: [
            { name: "individualsProblem", label: `Individual's ${"  "}  Problem/s` },
            {
              name: "functionalCapacity",
              label: "Functional   Capacity",
            },
            {
              name: "goalsOrExpectations",
              label: "Goals/Expectations",
            },
          ],
        },
      },

      // {
      //   input: {
      //     title: "",
      //     disabled: true,
      //     type: inputTypes.dropDown,
      //     options: [
      //       "Individual's Problem/s",
      //       "Functional Capacity",
      //       "Goals/Expectations",
      //     ],
      //     name: "indivPerspective",
      //   },
      // },
    ],
  },
  {
    title: "Diagnosis",
    titleImg: Diagnosis,
    bg: "#EC2027",
    subs: [
      {
        title: "",
        input: {
          type: inputTypes.dropDown,
          options: [
            "Specific Diagnosis",
            "Non Specific Diagnosis",
            "Red Flags",
          ],
          name: "diagnosis",
        },
      },
      {
        title: "Contribution of Pathology / Disease",
        input: {
          type: inputTypes.slider,
          name: "contribution_diagnosis",
        },
      },
      {
        title: "",
        input: {
          type: inputTypes.textArea,
          name: "diagnosis_input",
        },
      },
    ],
  },
  {
    title: "Stage of Disorder",
    titleImg: Stage,
    bg: "#F59230",

    subs: [
      {
        title: "",
        input: {
          type: inputTypes.dropDown,
          options: ["Acute", "Sub Acute", "Recurrent", "Chronic/Persistent"],
          name: "stageOfDisorder",
        },
      },
    ],
  },
  {
    title: "Pain Features",
    titleImg: PainHead,
    bg: "#33ADEE",
    subs: [
      {
        title: "Types",
        input: {
          type: inputTypes.checkBoxGroup,
          options: ["Nociceptive", "Neuropathic", "Nociplastic"],
          name: "type",
          multiselect: true,
          label:'Types'
        },
      },
      {
        title: "Characteristics",
        input: {
          type: inputTypes.slider,
          name: "characteristics",
          low: "Mechanical",
          medium:'Mixed',
          high: "Non-Mechanical",
        },
      },
      {
        title: "Sensitisation",
        input: {
          type: inputTypes.slider,
          name: "sensitisation",
          medium:'Moderate',
        },
      },
    ],
  },
  {
    title: "Psychological Considerations (Yellow Flags)",
    titleImg: Psychological,
    bg: "#F9EC31",
    name: "psyConsiderations",
    subs: [
      {
        title: "Cognitive Factors",
        input: {
          type: inputTypes.slider,
          name: "cognitiveFactors",
        },
      },
      {
        title: "Affective Factors",
        input: {
          type: inputTypes.slider,
          name: "affectiveFactors",
        },
      },
      {
        title: "Social Factors",
        input: {
          type: inputTypes.slider,
          name: "socialFactors",
        },
      },
    ],
  },
  {
    title: "Work Considerations (Blue and Black Flags)",
    titleImg: Work,
    bg: "#303991",
    name: "workConsiderations",
    subs: [
      {
        title: "Work Place Factors",
        input: {
          type: inputTypes.slider,
          name: "workPlaceFactors",
        },
      },
    ],
  },
  {
    title: "Lifestyle Considerations",
    titleImg: LifeStyle,
    bg: "#A1C9EB",
    name: "lifeStyleConsiderations",
    subs: [
      {
        title: "Lifestyle Factors",
        input: {
          type: inputTypes.slider,
          name: "lifeStyleFactors",
        },
      },
    ],
  },
  {
    title: "Whole Person Considerations",
    titleImg: WholePerson,
    bg: "#A05FCE",
    name: "wholePersonConsiderations",
    subs: [
      {
        title: "General Health & Co-Morbidities",
        input: {
          type: inputTypes.slider,
          name: "generalHealthCoMorbidities",
        },
      },
    ],
  },
  {
    title: "Functional Behaviours",
    titleImg: Functional,
    bg: "#33AF09",
    name: "functionalBehaviours",
    subs: [
      {
        title: "",

        input: {
          type: inputTypes.slider,
          name: "helpful",
          low: "Helpful (Protective)",
          medium:'Mixed',
          high: "Unhelpful (Provocative)",
        },
      },
      {
        title: "",

        input: {
          type: inputTypes.checkBoxGroup,
          name: "impairment",
          options: [
            "Impairment of movement",
            "Impairment of control",
            "Impairment of loading",
            "Pain Behaviours",
            "De-conditioning",
          ],
          multiselect: true,
        },
      },
    ],
  },
  {
    title: "Clinical Decision Making",
    titleImg: DecisionHead,
    bg: "#231F20",
    subs: [
      {
        title: "",
        input: {
          disabled: true,
          type: inputTypes.dropDown,
          options: ["Diagnosis", "Stage", "Important Contributing factors"],
          name: "clinicalDecisionMaking",
        },
      },

      {
        title: "Prognosis",
        input: {
          type: inputTypes.slider,
          name: "prognosis_time",
          low: "Uncomplicated",
          high: "Complicated",
        },
      },
      // {
      //   title: "Time Frame",
      //   input: {
      //     type: inputTypes.textArea,
      //     name: "clinicaltimeframe",
      //     label: "Time Frame",
      //   },
      // },
      {
        title: "",
        input: {
          type: inputTypes.textAreaGroup,
         textAreas:[
          { name: "goalsOrExpectationsClinical",
            label: "Goals",},
            { name: "clinicaltimeframe",
              label: "Time Frame",}
         ]
        },
      },
    ],
  },
  {
    title: "Additional Comments",
    titleImg: "",
    bg: "#566573",
    subs: [
      {
        title: "",
        input: {
          type: inputTypes.textArea,
          name: "additionalComments ",
          label: "Additional Comments ",
        },
      },
    ],
  },
  // {
  //   title: "",
  //   input: {
  //     type: inputTypes.dropDown,
  //     options: [],
  //     name: ""
  //   }
  // },
];
